<template>
  <v-container>
    <v-card elevation="0">
      <v-card-title class="justify-center">
        Welcome to the Application Portal
      </v-card-title>
      <v-card-text class="text-center">
        <p>
          If you already have a DEB ID, click below to proceed with your
          application.
        </p>
      </v-card-text>
      <v-row class="justify-center">
        <v-col cols="12" md="8" class="text-center pt-0">
          <v-btn link to="/home" color="success">Proceed</v-btn>
        </v-col>
      </v-row>

      <v-row class="justify-center mt-2">
        <v-col cols="12" md="8" class="text-center font-weight-medium pb-0">
          Don't have a DEB ID? Click Here
        </v-col>

        <v-col cols="12" md="8" class="text-center pt-0">
          <a href="https://deb.ugc.ac.in/StudentDEBId">
            https://deb.ugc.ac.in/StudentDEBId
          </a>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  methods: {
    downloadReceipt() {
      // Replace this with your actual logic to download the receipt
      this.$store.commit("showSnackbar", {
        message: "Downloading receipt...",
        color: "info",
      });

      // Example: download from API
      // window.open('/api/download_receipt?debId=xyz', '_blank');
    },
  },
};
</script>
